import { render, staticRenderFns } from "./VisitsForm.vue?vue&type=template&id=16fcb865&"
import script from "./VisitsForm.vue?vue&type=script&lang=js&"
export * from "./VisitsForm.vue?vue&type=script&lang=js&"
import style0 from "./VisitsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports